import type { IObjectivePossibleBeneficialChangesToFinancialSituationNatureOfPlannedChange } from './ObjectivePossibleBeneficialChangesToFinancialSituationNatureOfPlannedChange.interface';

export default class ObjectivePossibleBeneficialChangesToFinancialSituationNatureOfPlannedChange
  implements IObjectivePossibleBeneficialChangesToFinancialSituationNatureOfPlannedChange {
  reducedDebtCommitments: boolean;
  reducedDebtCommitmentsPeriodOfImpact: string;
  reducedDebtCommitmentsFinancialImpact: number;
  increasedIncome: boolean;
  increasedIncomePeriodOfImpact: string;
  increasedIncomeFinancialImpact: number;
  decreasingExpenses: boolean;
  decreasingExpensesPeriodOfImpact: string;
  decreasingExpensesFinancialImpact: number;

  static build = (
    data: IObjectivePossibleBeneficialChangesToFinancialSituationNatureOfPlannedChange
  ) => new ObjectivePossibleBeneficialChangesToFinancialSituationNatureOfPlannedChange(data);

  static blank = () =>
    new ObjectivePossibleBeneficialChangesToFinancialSituationNatureOfPlannedChange();

  /**
   * Constructor
   * @param {IObjectivePossibleBeneficialChangesToFinancialSituationNatureOfPlannedChange} data
   */
  constructor(
    data?: IObjectivePossibleBeneficialChangesToFinancialSituationNatureOfPlannedChange
  ) {
    this.reducedDebtCommitments = data?.reducedDebtCommitments === true;
    this.reducedDebtCommitmentsPeriodOfImpact =
      data?.reducedDebtCommitmentsPeriodOfImpact || '';
    this.reducedDebtCommitmentsFinancialImpact = parseFloat(
      data?.reducedDebtCommitmentsFinancialImpact || 0
    );
    this.increasedIncome = data?.increasedIncome === true;
    this.increasedIncomePeriodOfImpact = data?.increasedIncomePeriodOfImpact || '';
    this.increasedIncomeFinancialImpact = parseFloat(data?.increasedIncomeFinancialImpact || 0);
    this.decreasingExpenses = data?.decreasingExpenses === true;
    this.decreasingExpensesPeriodOfImpact = data?.decreasingExpensesPeriodOfImpact || '';
    this.decreasingExpensesFinancialImpact = parseFloat(
      data?.decreasingExpensesFinancialImpact || 0
    );
  }
}
